import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import BarChartIcon from '@mui/icons-material/BarChart';
import { Checkbox } from '@mui/material';
import { Table } from '../../components/table/Table';
import { getRounded } from '../../lib/numbers';
import YieldStats from './YieldStatsGraph';
import { usePermission } from '../../hooks/use-permission';
import { actions, selectors } from '../../store/dux/yield-dux';
import { selectors as growerSelectors } from '../../store/dux/grower-dux';
import { useContext } from './context.jsx';
import { useCurrentUser } from '../../hooks/use-current-user.js';

export default function GrowerYieldCleanTab() {
  const dispatch = useDispatch();
  const [statsOpen, setStatsOpen] = useState(false);
  const growerId = useSelector(growerSelectors.selectedId) || '';
  const cleanYield = useSelector(selectors.cleanYield);
  const manageYield = usePermission('MANAGE_YIELD');
  const { year } = useContext();
  const { username } = useCurrentUser();

  async function handleApproved(e, field) {
    e.stopPropagation();
    await dispatch(
      actions.toggleYieldApproval(username, field, growerId, `${year}`),
    );
  }

  const columns = [
    { field: 'harvestedCrop', headerName: 'Harvested Crop', flex: 1 },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
    },
    {
      field: 'coverage',
      headerName: 'Coverage',
      valueGetter: (params) => getRounded(params.value, 0),
      flex: 1,
      align: 'right',
    },
    {
      field: 'avgMoisture',
      headerName: 'Average Moisture',
      type: 'number',
      valueFormatter: (params) =>
        params.value ? `${getRounded(params.value, 2, true)}%` : '',
      flex: 1,
      align: 'right',
    },
    {
      field: 'avgYield',
      headerName: 'Average Dry Bu/Acre',
      valueGetter: (params) => getRounded(params.value, 2, true),
      flex: 1,
      align: 'right',
    },
    {
      field: 'minYield',
      headerName: 'Min Bu/Acre',
      valueGetter: (params) => getRounded(params.value, 2, true),
      flex: 1,
      align: 'right',
    },
    {
      field: 'maxYield',
      headerName: 'Max Bu/Acre',
      valueGetter: (params) => getRounded(params.value, 2, true),
      flex: 1,
      align: 'right',
    },
    {
      field: 'postCalibrated',
      headerName: 'Post Calibrated',
      flex: 1,
    },
    {
      headerName: 'Approved',
      field: 'yieldapproved',
      renderCell: ({ row }) => (
        <Checkbox
          color="primary"
          data-testid="check-approved"
          disabled={!row.avgYield || !manageYield}
          checked={row.yieldapproved}
          onClick={(event) => handleApproved(event, row)}
        />
      ),
      valueGetter: () => '',
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Stats',
      flex: 1,
      getActions: ({ row }) => [
        <GridActionsCellItem
          icon={<BarChartIcon />}
          label="Show Stats"
          onClick={() => setStatsOpen(row)}
          data-testid={'yield-stats'}
        />,
      ],
    },
  ];

  return (
    <>
      <Table
        fields={cleanYield || []}
        loading={!cleanYield}
        initialState={{
          sorting: {
            sortModel: [{ field: 'fieldName', sort: 'asc' }],
          },
        }}
        columns={columns}
      />

      {statsOpen ? (
        <YieldStats
          field={statsOpen}
          year={year}
          onClose={() => setStatsOpen(false)}
        />
      ) : null}
    </>
  );
}
